import { render, staticRenderFns } from "./InputRitchURL.vue?vue&type=template&id=24fea87c&"
import script from "./InputRitchURL.vue?vue&type=script&lang=js&"
export * from "./InputRitchURL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports